// ProjectedIncome.js
import React from "react";
import labels from "utils/LocalizedStrings";
import InfoPopup from "common/InfoPopup/InfoPopup";

const ProjectedIncome = ({ projectionData, age }) => {
  if (!projectionData) return null;

  const { lifeTimeProjectionZeroPercent, lifeTimeProjectionTwoPercent } =
    projectionData;

  return (
    <div className="row mb-3">
      <div className="mt-5 pt-3 border-top">
        <h6 className="fw-bold mb-1">
          {labels?.dashboard?.lifetimeIncomeProjections?.projectedAnnualIncome}
        </h6>
        <p className="text-muted small mb-4">
          (
          {
            labels?.dashboard?.lifetimeIncomeProjections
              ?.projectedAnnualIncomeSubText
          }
          )
        </p>
      </div>

      {/* Table Header */}
      <div className="row mb-3 border-bottom">
        <div className="table-header d-flex justify-content-between align-items-center mb-2">
          <div className="fw-bold col-md-4">
            {labels?.dashboard?.lifetimeIncomeProjections?.projectedIncomeAge}
          </div>
          <div className="fw-bold col-md-4 text-center">
            {labels?.dashboard?.lifetimeIncomeProjections?.projectedIncome2Per}
            <InfoPopup
              position={"top"}
              content={
                labels?.dashboard?.lifetimeIncomeProjections
                  ?.projectedIncome2PerPopOver
              }
              trigger={"focus"}
            />
          </div>
          <div className="col-md-6 text-center">
            <strong>
              {
                labels?.dashboard?.lifetimeIncomeProjections
                  ?.projectedIncome0Per
              }
            </strong>{" "}
            <div>
              <small className="text-muted">
                ({
                  labels?.dashboard?.lifetimeIncomeProjections
                    ?.projectedIncomeWorstCase
                })
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* Table Body */}
      <div className="row mb-3 border-bottom">
        <div className="table-body d-flex justify-content-between align-items-center pb-3">
          <div className="col-md-4">{age}</div>

          <div className="col-md-4 text-center">
            {lifeTimeProjectionTwoPercent
              ? `$${Number(lifeTimeProjectionTwoPercent).toFixed(2)}`
              : "--"}
          </div>

          <div className="col-md-6 text-center">
            {lifeTimeProjectionZeroPercent
              ? `$${Number(lifeTimeProjectionZeroPercent).toFixed(2)}`
              : "--"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectedIncome;
